import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { AgreementsAutocomplete } from "@shared/components/AutocompleteFields";

export const ReferralListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("referral_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("referral_admin.fields.agreement")}
        />
      </Grid>
    </Grid>
  );
});

